import { createContext, useContext } from 'react';

/**
 * The meeting context object and its hook, on their own.
 *
 * Kept apart from the provider (context/MeetingContext.js) because the provider
 * pulls in the whole media stack. Screens that only ask "am I in a meeting?" -
 * the details drawer, the calendar - read it from here and stay light. Outside
 * the provider (the public guest page, tests) the answer is simply null.
 */
export const MeetingContext = createContext(null);

export const useMeeting = () => useContext(MeetingContext);
